import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CourseDetail from "./pages/CourseDetail";
import Assessments from "./pages/Assessments";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Panel from "./pages/Panel";
import AdminPage from "./pages/AdminPage";
import InstructorPage from "./pages/InstructorPage";
import BlogPage from "./pages/BlogPage";
import AppointmentPage from "./pages/AppointmentPage";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import ContactForm from "./components/ContactForm"; 
import UserProfilePage from './components/UserProfilePage';


export const ApiUrlContext = React.createContext('https://iyiliginmucitleri.com/api');


// Route koruma bileşeni
const ProtectedRoute = ({ children, requiredRole, userRole }) => {
  if (requiredRole === "admin" && userRole !== "admin") {
    return <Redirect to="/" />;
  }
  if (requiredRole === "instructor" && !["instructor", "admin"].includes(userRole)) {
    return <Redirect to="/" />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const apiUrl = "https://iyiliginmucitleri.com/api";
  const [userRole, setUserRole] = useState("student");
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (isAuthenticated) {
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${apiUrl}/user/profile`, {
            headers: { Authorization: token ? `Bearer ${token}` : "" }
          });
          if (response.ok) {
            const userData = await response.json();
            setUserRole(userData.role || "student");
            setUser({
              name: userData.name || "Kullanıcı",
              email: userData.email,
              role: userData.role || "student"
            });
          } else if (response.status === 401) {
            localStorage.removeItem("token");
            setIsAuthenticated(false);
            setUser(null);
            setUserRole("student");
          }
        } catch (error) {
          console.error("Kullanıcı bilgileri alınamadı:", error);
        }
      }
    };

    fetchUserData();
  }, [isAuthenticated, apiUrl]);

  const handleAuth = (token, userData) => {
    localStorage.setItem("token", token);
    setIsAuthenticated(true);
    if (userData) {
      setUser(userData);
      setUserRole(userData.role || "student");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setUserRole("student");
    setUser(null);
  };

  return (
    <ApiUrlContext.Provider value="https://iyiliginmucitleri.com/api">
      <Router>
        {!isAuthenticated ? (
          // GİRİŞ YAPILMAMIŞSA
          <Switch>
            <Route path="/register">
              <RegisterPage onAuth={handleAuth} />
            </Route>
            <Route path="/forgot-password">
              {React.createElement(require("./pages/ForgotPassword").default)}
            </Route>
            <Route path="/reset-password">
              {React.createElement(require("./pages/ResetPassword").default)}
            </Route>
            <Route path="/auth-success" component={require("./pages/AuthSuccess").default} />
            <Route path="/">
              <LoginPage onAuth={handleAuth} />
            </Route>
          </Switch>
        ) : (
          // GİRİŞ YAPILMIŞSA
          <div className="app-root" style={{ display: "flex", height: "100vh", background: "#f7f7f7", position: "relative" }}>
            {isMobile ? (
              <>
                {/* Mobil sidebar */}
                <div
                  style={{
                    display: sidebarOpen ? "block" : undefined,
                    position: "fixed",
                    zIndex: 100,
                    height: "100vh",
                    left: sidebarOpen ? 0 : -260,
                    top: 0,
                    transition: "left 0.2s",
                    background: "#fff"
                  }}
                  className="sidebar-responsive"
                >
                  <Sidebar onClose={() => setSidebarOpen(false)} isMobile />
                </div>
                {sidebarOpen && (
                  <div
                    className="sidebar-overlay"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      background: "rgba(0,0,0,0.3)",
                      zIndex: 99
                    }}
                    onClick={() => setSidebarOpen(false)}
                  />
                )}
              </>
            ) : (
              <Sidebar isMobile={false} />
            )}

            {/* Ana içerik */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                filter: isMobile && sidebarOpen ? "blur(2px)" : "none",
                pointerEvents: "auto",
                transition: "filter 0.2s"
              }}
            >
              <Topbar 
                onLogout={handleLogout} 
                onMenuClick={() => setSidebarOpen(!sidebarOpen)} 
                user={user}
              />
              <div className="main-content" style={{ flex: 1, padding: "32px", overflowY: "auto" }}>
                <Switch>
                  <Route exact path="/panel" component={Panel} />
                  <Route exact path="/" render={() => <Redirect to="/panel" />} />
                  <Route exact path="/courses" component={HomePage} />
                  <Route path="/assessments" component={Assessments} />
                  <Route path="/course/:id" component={CourseDetail} />
                  <Route path="/blog/:courseId" component={BlogPage} />
                  <Route path="/contact" component={ContactForm} />
                  <Route path="/appointments" component={AppointmentPage} />
                  
                  {/* PROFILE ROUTE'u buraya ekledik */}
                  <Route path="/profile">
                    <UserProfilePage />
                  </Route>
                  
                  <Route path="/admin">
                    <ProtectedRoute requiredRole="admin" userRole={userRole}>
                      <AdminPage />
                    </ProtectedRoute>
                  </Route>
                  <Route path="/instructor">
                    <ProtectedRoute requiredRole="instructor" userRole={userRole}>
                      <InstructorPage />
                    </ProtectedRoute>
                  </Route>
                  <Redirect to="/panel" />
                </Switch>
              </div>
            </div>
          </div>
        )}
      </Router>
    </ApiUrlContext.Provider>
  );
}

export default App;
